<template>
  <div class="named-carts-consumer-details">
    <h3 v-if="hasHeader" class="named-carts-consumer-details__header">CUSTOMER</h3>
    <a :href="consumer.url" class="named-carts-consumer-details__link">
      <div class="named-carts-consumer-details__info named-carts-consumer-details__info--name">
        {{ consumer.firstName }} {{ consumer.lastName }}
      </div>
      <div v-if="consumer.companyName" class="named-carts-consumer-details__info">
        {{ consumer.companyName }}
      </div>
      <div class="named-carts-consumer-details__info">
        <span v-if="consumer.city">{{ consumer.city }}</span>
        <span v-if="consumer.stateName">, {{ consumer.stateName }}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "NamedCartsConsumerDetails",
  props: {
    consumer: {
      type: Object,
      required: true
    },
    hasHeader: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.named-carts-consumer-details {
  &__info {
    font-size: 0.75rem;
    line-height: 1.43;
    color: $text-black;

    &--name {
      font-weight: 700;
      font-size: 0.875rem;
    }
  }

  &__header {
    font-size: 0.75rem;
    font-weight: 700;
    margin-bottom: 2px;
  }

  &__link {
    &:not([href]) {
      text-decoration: none;
    }
  }
}
</style>
